import { AfterViewInit, Component } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ChargeInformationService, ChargeType, PartyDto, PartyService } from '@app/api/dmc';
import { FormApiService } from '@app/core/services/form-api.service';
import { InputGroupComponent } from '@shared/components/input/input-group/input-group.component';
import { LabelDirective } from '@shared/components/input/label/label.directive';
import { InputDirective } from '@shared/components/input/input/input.directive';
import { TranslatePipe } from '@ngx-translate/core';
import { KeyValue } from '@shared/interfaces/key-value/key-value';
import { enumToKeyValue } from '@app/core/utils/enum-to-key-value';
import { SelectDirective } from '@shared/components/input/select/select.directive';
import { HasUnsavedChanges } from '@app/core/guards/unsaved-changes.guard';

@Component({
  selector: 'app-dashboard-request-price',
  imports: [
    ReactiveFormsModule,
    InputGroupComponent,
    LabelDirective,
    InputDirective,
    TranslatePipe,
    SelectDirective
  ],
  templateUrl: './dashboard-request-price.component.html',
  styleUrl: './dashboard-request-price.component.css'
})
export class DashboardRequestPriceComponent implements AfterViewInit, HasUnsavedChanges {
  public hasUnsavedChanges(): boolean {
    return this.form.dirty;
  }

  public form: FormGroup = new FormGroup({
    chargeTypeId: new FormControl(null, Validators.required),
    chargeType: new FormControl(null, Validators.required),
    owner: new FormControl(null, Validators.required),
    start: new FormControl(null, Validators.required),
    end: new FormControl(null),
  });

  public chargeTypeList: KeyValue[] = enumToKeyValue(ChargeType, { omitKeys: ['NotSpecified'], prefixValue: 'enum.chargetype.'});
  public chargeOwnerEnergyPartyList: KeyValue[] = [];
  private chargeInformationParties: PartyDto[] = [];

  public element?: any;

  constructor(
    private readonly chargeInformationService: ChargeInformationService,
    private readonly formApiService: FormApiService,
    private readonly partyService: PartyService,
  ) {

    this.partyService.partyGetChargeInformationPartiesGet().subscribe((data: PartyDto[]) => {
      this.chargeInformationParties = data ?? [];

      this.chargeOwnerEnergyPartyList = this.chargeInformationParties.map((item: PartyDto) => ({
        key: item.identification ?? '',
        value: item.name ?? '',
      }))
    });
  }

  public ngAfterViewInit(): void {
    if (this.element?.chargeType && this.element?.chargeTypeId) {
      this.form.get('chargeType')?.setValue(this.element.chargeType);
      this.form.get('chargeTypeId')?.setValue(this.element.chargeTypeId);
    }
  }

  public submit(): void {
    this.formApiService.submit(
      this.form,
      (data) => this.chargeInformationService.chargeInformationRequestChargeInformationsPut(data),
      {
        preprocess: (data: any) => ({
          ...data,
          start: new Date(data.start).toISOString().split('T')[0],
          end: new Date(data.end).toISOString().split('T')[0],
        }),
        closeModal: true,
        successMessage: 'dashboard.request.success'
      }
    )
  }
}
